import React, {useEffect, useState} from 'react'

const AccountCreatedModal = props => {
    const [open, setOpen] = useState(props.isVisible)

    useEffect(() => {
      setOpen(props.isVisible);
    }, [props.isVisible]);

    if(!props.isVisible){
        return <></>
    }
    return (
        <div className="inset-0 fixed bg-gray-500 bg-opacity-75 flex items-center justify-center">
            <div className="inset-0 fixed"></div>
               <div className="bg-primary border border-primary-dark rounded-lg p-4 relative text-white lg:w-106">
                <span onClick={()=>props.onCloseTrigger()} className="text-2xl absolute right-4 top-2 text-white cursor-pointer">&times;</span>
               <strong>Your account has been created</strong>
                <p>Please check your email with confirmation</p>
            <button onClick={()=>props.onCloseTrigger()} className="bg-white rounded-full px-20 py-1 text-black mx-auto mt-4 flex cursor-pointer">Ok</button></div>                     
        </div>
    )
}


export default AccountCreatedModal
